import { Map } from 'immutable';
import * as actionTypes from './actionTypes';
import { createReducer } from 'utils/redux';
import { fromJS } from 'redux-little-router/lib/immutable/util/immutable';

const initialState = new Map({});

const onGetDocuments = (state, { payload: { cardId } }) =>
  state.setIn([cardId, 'loading'], true).setIn([cardId, 'error'], null);

const onGetDocumentsSuccess = (state, { payload: { cardId, data } }) =>
  state.setIn([cardId, 'loading'], false).setIn([cardId, 'documents'], fromJS(data));

const onGetDocumentsError = (state, { payload: { cardId, error } }) =>
  state.setIn([cardId, 'loading'], false).setIn([cardId, 'error'], error);

export default createReducer(initialState, {
  [actionTypes.GET_DOCUMENTS]: onGetDocuments,
  [actionTypes.GET_DOCUMENTS_SUCCESS]: onGetDocumentsSuccess,
  [actionTypes.GET_DOCUMENTS_FAILURE]: onGetDocumentsError,
});
